import React from "react";
import point from "./../../../../../Images/point.png";

const TrendyHairHighlightFaceFraming = () => {
  return (
    <div className="blogWhat-content">
      <h5>1. Face-Framing Money Piece Highlights 💫</h5>
      <p>
        The money piece highlight trend continues to dominate in 2025! This
        technique involves adding bright highlights around the face, enhancing
        your facial features, and creating a sun-kissed, fresh look. It works
        beautifully with all hair highlights colors, including blonde, caramel,
        copper, and even pastels.
      </p>
      <ul>
        <h4>Why It’s Trending:</h4>
        <li>
          <span>
            <img src={point} alt="point" />
            Instantly brightens the face{" "}
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Works on all hair lengths and types
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Low-maintenance but high-impact
          </span>
        </li>
      </ul>
    </div>
  );
};

export default TrendyHairHighlightFaceFraming;
